<!--
    系统中心-角色权限-角色详情-权限组件
    作用：循环显示路由结构数据
    组件：AppCheckMap、AppCheckBox
-->
<template>
  <div class="role_permissions_box">
    <AppCheckMap
      :value="value"
      class="role-permissions"
      @input="value => $emit('input', value)"
    >
      <template v-if="options">
        <AppCheckBox
          v-for="level1 in options"
          :key="level1.id"
          :value="level1.id"
          :label="level1.name"
          class="role-permissions__level1"
          :direction="level1.children && level1.children.find(item => item.children) ? 'column' : 'row'"
        >
          <template v-if="level1.children">
            <AppCheckBox
              v-for="level2 in level1.children"
              :key="level2.id"
              :value="level2.id"
              :label="level2.name"
              :class="level2.children && level2.children.find(item => item.children) ? 'role-permissions__level2' : ''"
              :direction="level2.children && level2.children.find(item => item.children) ? 'column' : 'row'"
            >
              <template v-if="level2.children">
                <AppCheckBox
                  v-for="level3 in level2.children"
                  :key="level3.id"
                  :value="level3.id"
                  :label="level3.name"
                  class="role-permissions__level3"
                  :direction="level3.children && level3.children.find(item => item.children) ? 'column' : 'row'">
                  <template v-if="level3.children">
                    <AppCheckBox
                      v-for="level4 in level3.children"
                      :key="level4.id"
                      :value="level4.id"
                      :label="level4.name"
                      class="role-permissions__level4"
                      :direction="level4.children && level4.children.find(item => item.children) ? 'column' : 'row'">
                      <template v-if="level4.children">
                        <AppCheckBox
                          v-for="level5 in level4.children"
                          :key="level5.id"
                          :value="level5.id"
                          :label="level5.name"
                          class="role-permissions__level5"
                          direction="row">
                          <template v-if="level5.children">
                            <AppCheckBox
                              v-for="level6 in level5.children"
                              :key="level6.id"
                              :value="level6.id"
                              :label="level6.name"
                              class="role-permissions__level6"
                            />
                          </template>
                        </AppCheckBox>
                      </template>
                    </AppCheckBox>
                  </template>
                </AppCheckBox>
              </template>
            </AppCheckBox>
          </template>
        </AppCheckBox>
      </template>
    </AppCheckMap>
  </div>
</template>

<script>
/**
 * 权限列表组件
 * @author huojinzhao
 * @param {Array}   options   权限数组
 * @param {Array}   value     选中的权限
 */

export default {
  name: 'Permissions',

  props: {
    options: {
      type: Array,
      required: true,
    },

    value: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.role_permissions_box {
  .role-permissions{
    --border-color: rgb(220, 223, 230);

    border-top: 1px solid var(--border-color);
  }

  .role-permissions .app-check-box__self {
    margin-right: 2.9em;
  }

  .role-permissions .app-check-box__children {
    flex-wrap: wrap;
  }

  .role-permissions__level1 {
    border-bottom: 1px solid var(--border-color);
  }
  .role-permissions__level1:last-child {
    border: none;
  }

  .role-permissions__level2 {
    border-bottom: 1px solid var(--border-color);
  }

  .role-permissions__level2:last-child {
    border: none;
  }

  .role-permissions__level3 {

  }
}
</style>



// WEBPACK FOOTER //
// src/views/Role/components/Permissions.vue